var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "searchForm",
              attrs: { model: _vm.queryCondition, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("fpaManage.permanent.fpaNo"),
                                    prop: "fpaNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.fpaNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "fpaNo",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.fpaNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "fpaManage.permanent.fpaName"
                                    ),
                                    prop: "fpaName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.fpaName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "fpaName",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.fpaName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Facility Name",
                                    prop: "facilityName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.facilityName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "facilityName",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.facilityName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Status", prop: "status" } },
                                [
                                  _c("ic-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      table: "TT_FPA",
                                      field: "REPORT_STATUS",
                                    },
                                    model: {
                                      value: _vm.queryCondition.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "flexBox",
                                          attrs: {
                                            label: _vm.$t(
                                              "fpaManage.permanent.deadline"
                                            ),
                                            prop: "startDate",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options":
                                                _vm.PickerOptionsStart,
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.startDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.startDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "flexBox",
                                          attrs: {
                                            label: "To",
                                            prop: "endDate",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options":
                                                _vm.PickerOptionsEnd,
                                            },
                                            model: {
                                              value: _vm.queryCondition.endDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "endDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.endDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.queryData },
                    },
                    [_vm._v("Search")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.restQueryFormThis },
                    },
                    [_vm._v("Reset")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "action-btn-row" }, [
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.fpaReportDownload },
              },
              [_vm._v("Download")]
            ),
            _vm._v(
              " " +
                _vm._s(_vm.$t("fpaManage.permanent.toExpireCount")) +
                " : " +
                _vm._s(_vm.toExpireCount) +
                " " +
                _vm._s(_vm.$t("fpaManage.permanent.expiredCount")) +
                " : " +
                _vm._s(_vm.expiredCount) +
                " "
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-table",
        {
          ref: "tableFpaList",
          attrs: {
            data: _vm.tableFpaList,
            border: "",
            "highlight-current-row": "",
            "max-height": "420",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "fpaNo",
              label: _vm.$t("fpaManage.permanent.fpaNo"),
              "min-width": "120px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "fpaName",
              label: _vm.$t("fpaManage.permanent.fpaName"),
              "min-width": "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "facilityCode",
              label: "Facility Code",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "facilityName",
              label: "Facility Name",
              "min-width": "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "productOrCommodityPurchased",
              label: "Product",
              "min-width": "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "agreementStartDate",
              label: "Start Date",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.agreementStartDate,
                            "YYYY-MM-DD"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "agreementEndDate",
              label: "End Date",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.agreementEndDate,
                            "YYYY-MM-DD"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "status",
              label: "Status",
              "min-width": "80",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryCondition.pageNum,
              "page-sizes": _vm.pageSizeList,
              "page-size": _vm.queryCondition.pageSize,
              layout: _vm.pageLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageNumberChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }